import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Column } from '../../model/common/column';
import { TranslateDirective } from '@ngx-translate/core';
import { TableModule } from '@openng/optimus-ui/table';

// Note cannot use onPush here because the click event needs to be able to change
// the sort icon.
@Component({
  selector: 'app-table-column-header',
  templateUrl: './table-column-header.component.html',
  styleUrls: ['./table-column-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateDirective, TableModule],
})
export class TableColumnHeaderComponent {
  @Input() column!: Column;
}
